import { gql, Variables } from 'graphql-request'
import useLazyQuery from '@/hooks/useLazyQuery'
import { OrderHistory, QueryDataError } from '@/resources/types'
import { Dispatch, SetStateAction } from 'react'
import { UseQueryResult } from '@/proxy/react-query'

export const ORDER_HISTORY = gql`
  query sellerOrderHistory(
    $pagination: PaginationInput!
    $period: PeriodInput!
    $search: OrderHistorySearchInput
    $filter: OrderHistoryFilterInput
  ) {
    orderHistory(
      pagination: $pagination
      period: $period
      search: $search
      filter: $filter
    ) {
      id
      number
      date
      customer {
        name
      }
      delivery {
        type
        deliveryDate {
          startDate
          endDate
        }
      }
      payment {
        type
      }
      charging {
        coupon {
          code
        }
        discount
        total
      }
      rating {
        value
      }
      status
      courierEmail
    }
  }
`

export const ORDER_HISTORY_QUERY_KEY = 'useOrderHistory'

export interface OrderHistoryData {
  orderHistory?: OrderHistory[]
  error?: QueryDataError
}

export const useOrderHistory = (): [
  Dispatch<SetStateAction<Variables | null>>,
  UseQueryResult<OrderHistoryData>,
] =>
  useLazyQuery({
    key: ORDER_HISTORY_QUERY_KEY,
    query: ORDER_HISTORY,
    queryOptions: { gcTime: 0 },
  }) as unknown as [
    Dispatch<SetStateAction<Variables | null>>,
    UseQueryResult<OrderHistoryData>,
  ]
